import { Terms, Privacy, Support } from "../../pages";

export const routes = [
  {
    id: "privacy",
    path: ":user_type/privacy_policy/:version/:lang",
    title: "ui.mainMenu.privacyPolicy",
    element: <Privacy />,
  },
  {
    id: "term",
    path: ":user_type/terms_of_use/:version/:lang",
    title: "ui.mainMenu.termsOfUse",
    element: <Terms />,
  },
  {
    id: "support",
    path: ":user_type/support/:version/:lang",
    title: "ui.mainMenu.support",
    element: <Support />,
  },
];
